import { getPublishDate, getShouldPublishImmediately, getSubcategory, getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getIsScheduled, getUnifiedPublishType
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/selectors/publishSelectors';
import { useSelector } from 'react-redux';
// @ts-expect-error Untyped module
import { publishDateIsBackdated } from 'ContentEditorUI/js/utils/publishUtils';
// @ts-expect-error Untyped module
import { getIsSchedulingUpdate } from '../redux/selectors/postPublishSelectors';
import { useDispatch } from 'react-redux';
import { BLOG_API_BASE_URL } from '../Constants';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { fetchContent, fetchHardSavedContent
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/contentActions';
import { updatePublishDate, showPublishErrors, trackPublish
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/publishActions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { displayPublishSuccessAlert } from 'ContentEditorUI/utils/displayPublishSuccessAlert';
// @ts-expect-error Untyped module
import { getPostSettingsFullUrl } from '../redux/selectors/postSettingsSelectors';
import { PublishTypes } from 'ContentEditorUI/constants/PublishTypes';
import { getShouldOpenPostPublishCustomDomainSetupModal } from 'ContentEditorUI/redux/selectors/modalSelectors';
// @ts-expect-error Untyped module
import { togglePostPublishDomainSetupModal } from 'ContentEditorUI/redux/actions/appActions';
import { markActionComplete } from 'user-context/onboarding';
import { createABlogPost } from 'getting-started-shared-tasks/taskNames';
// @ts-expect-error Untyped module
import { save as saveAction } from '../redux/actions/postSaveActions';
// @ts-expect-error Untyped module
import PublishApi from 'ContentEditorUI/api/PublishApi';
import { getBaseContentUrl, fetch as fetchContentApi
// @ts-expect-error Untyped module
} from 'ContentEditorUI/api/ContentApi';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
// @ts-expect-error Untyped module
import { getBaseApiUrl } from 'ContentEditorUI/redux/selectors/extraInitialStateSelectors';
import { getActiveDomainIsConnected, getActiveDomainIsInternal } from 'ContentEditorUI/redux/selectors/portalDomainsSelectors';
// @ts-expect-error Untyped module
import { getHasAnyLayoutSections } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsUngatedForCMPPublishing } from '../redux/selectors/authSelectors';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
// @ts-expect-error Untyped module
import { openModal } from 'ContentEditorUI/redux/actions/appActions';
import { getHasBlogRemixModalAccess } from '../redux/selectors/authSelectors';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { getHasContentRemixWriteAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const usePublishModalType = () => {
  const publishType = useSelector(getUnifiedPublishType);
  // Seems that this is impossible based on possible return values of
  // getPublishType?
  // @ts-expect-error This comparison appears to be unintentional because the types '"update" | "publish" | "schedule"' and '"unpublish"' have no overlap.ts(2367)
  const isUnpublishing = publishType === 'unpublish';
  const publishDate = useSelector(getPublishDate);
  const isScheduled = useSelector(getIsScheduled);
  const shouldPublishImmediately = useSelector(getShouldPublishImmediately);
  if (isScheduled && isUnpublishing) {
    return 'unschedule';
  } else if (isUnpublishing) {
    return 'unpublish';
  } else if (!shouldPublishImmediately && publishDate && publishDateIsBackdated(publishDate)) {
    return 'backDate';
  }
  return publishType;
};
export const usePublishLifecycleHandlers = () => {
  const dispatch = useDispatch();
  const shouldOpenPostPublishCustomDomainSetupModal = useSelector(getShouldOpenPostPublishCustomDomainSetupModal);
  const postSettingsFullUrl = useSelector(getPostSettingsFullUrl);
  const contentId = useSelector(getContentModelId);
  const categoryId = useSelector(getCategoryId);
  // TODO: to be replaced with CMP API in near future
  const baseContentUrl = getBaseContentUrl({
    baseUrl: useSelector(getBaseApiUrl),
    categoryId,
    subcategory: useSelector(getSubcategory),
    contentId
  });
  const domainIsConnected = useSelector(getActiveDomainIsConnected);
  const domainIsInternal = useSelector(getActiveDomainIsInternal);
  const isDndPage = useSelector(getHasAnyLayoutSections);
  const appState = useSelector(state => state);
  const isSchedulingUpdate = useSelector(getIsSchedulingUpdate);
  const shouldUseCMPPublicationAPI = useSelector(getIsUngatedForCMPPublishing);
  const hasBlogRemixModalAccess = useSelector(getHasBlogRemixModalAccess);
  const hasContentRemixWriteAccess = useSelector(getHasContentRemixWriteAccess);
  const refetchContent = (isFetchAfterPublish = false) => {
    // Delay fetching content as the `updated` timestamp may be ahead of X-Last-Modified-Timestamp
    // when publish is backdated or scheduled immediately.
    setTimeout(() => {
      const params = {
        isFetchAfterPublish,
        baseUrl: BLOG_API_BASE_URL
      };
      dispatch(fetchContent(params));
      dispatch(fetchHardSavedContent(params));
    }, 1000);
  };
  const onPublishSuccess = (__data, publishType) => {
    markActionComplete(createABlogPost).catch(err => console.error(err));
    if (!shouldUseCMPPublicationAPI) {
      // TODO: Remove when API is updated so that publish-action returns the publishDate.
      // This is temp workaround to sync publishDate in FE state with BE after a publish.
      // We need this because publish-action updates publishDate AFTER our final pre-publish save request.
      fetchContentApi(baseContentUrl).then(({
        publishDate
      }) => {
        if (publishDate) {
          dispatch(updatePublishDate(publishDate));
        }
      }).catch();
    }
    if (shouldOpenPostPublishCustomDomainSetupModal && publishType === PublishTypes.publish) {
      dispatch(togglePostPublishDomainSetupModal(true));
    } else {
      if (publishType === PublishTypes.publish && hasBlogRemixModalAccess && hasContentRemixWriteAccess) {
        dispatch(openModal(MODAL_TYPES.CONTENT_REMIX));
        UsageTracker.trackEditorInteraction({
          action: 'Opened remix modal',
          event: 'opened-remix-modal-from-publish'
        });
      }
      displayPublishSuccessAlert({
        contentType: 'blog',
        publishType: publishType || PublishTypes.publish,
        publishedContentUrl: postSettingsFullUrl,
        canScheduleWithContentCrmObject: shouldUseCMPPublicationAPI
      });
    }
    refetchContent(true);
  };
  const onUnpublishSuccess = () => {
    refetchContent();
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.success.message"
      }),
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.success.text"
      }),
      type: 'success'
    });
  };
  const onPublishError = errorResponse => {
    showPublishErrors(errorResponse.responseJSON || {}, categoryId, appState);
  };
  const onUnpublishError = errorResponse => {
    showPublishErrors(errorResponse.responseJSON || {}, categoryId, appState);
  };
  const trackPublishEvent = (isSuccessful, publishType) => {
    trackPublish({
      contentId,
      isConnectedAndCustomDomain: domainIsConnected && !domainIsInternal,
      isDndPage,
      publishType,
      skipPublishRedirect: true,
      usageTrackingProperties: {
        screen: 'blog-editor',
        isSchedulingUpdate
      },
      isSuccessful
    });
  };
  const publishUnpublishAPICallback = isUnpublish => {
    return PublishApi.publish({
      baseContentUrl,
      timeout: 20000,
      unpublish: isUnpublish
    });
  };
  return {
    saveAction,
    publishUnpublishAPICallback,
    onPublishSuccess,
    onUnpublishSuccess,
    onPublishError,
    onUnpublishError,
    trackPublishEvent
  };
};